import(/* webpackMode: "eager" */ "/app/src/app/(dashboard)/patients/layout.tsx");
